module.exports = __webpack_public_path__ + "img/header.e459dfe.svg";